export default "__VITE_ASSET__CiYzc9W6__"